






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class CanvasEditor extends Vue {
  @Prop({required: false, default: 5})
  public size!: number;

  @Prop({required: true, default: '#f05b41'})
  public color!: string;

  @Prop({required: false, default: false})
  public saving?: boolean;

  @Prop({required: false, default: false})
  public erase!: boolean;


  private isPaint: boolean = false;
  private lastPointerPosition: any = null;
  private context: any = null;
  private canvas: any = null;
  private initialised: boolean = false;
  private loaded: boolean = false;
  private loading: boolean = false;

  private configKonva: any = {
      width: 1000,
      height: 1000,
  };

  public getDataAsBase64() {
    return this.canvas.toDataURL('image/png');
  }

  public getDataAsBlob() {
    const data = this.getDataAsBase64();
    const block = data.split(';');
    // Get the content type of the image
    const contentType = block[0].split(':')[1]; // In this case "image/gif"
    // get the real base64 content of the file
    const realData = block[1].split(',')[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

    // Convert it to a blob to upload
    const blob = this.b64toBlob(realData, contentType);
    return blob;
  }

  public setImage(imageUrl: any) {
    this.loading = true;
    this.loaded = false;
    const self = this;

    setTimeout(() => {
      const container = (self.$refs.container as any);

      const maxWidth = container.clientWidth;
      const maxHeight = container.clientHeight;

      self.loading = false;
      const logoImg = new Image();

      logoImg.onload = () => {
        const logoWidthHeightRatio: number = logoImg.width / logoImg.height;
        const containerRatio: number = maxWidth / maxHeight;

        let imageWidth = 0;
        let imageHeight = 0;

        if (containerRatio > logoWidthHeightRatio) {
          imageHeight = maxHeight;
          imageWidth = maxHeight * logoWidthHeightRatio;
        } else {
          imageWidth = maxWidth;
          imageHeight = maxWidth / logoWidthHeightRatio;
        }

        self.canvas = document.createElement('canvas');
        self.canvas.width = imageWidth;
        self.canvas.height = imageHeight;



        this.configKonva.width = imageWidth;
        this.configKonva.height = imageHeight;

        this.initialised = true;

        this.context = this.canvas.getContext('2d');
        this.context.lineJoin = 'round';

        self.context.drawImage(logoImg, 0, 0, imageWidth, imageHeight);
        self.loaded = true;
      };
      logoImg.src = imageUrl;

    }, 200);
  }

  get configImage() {
      return {
          image: this.canvas,
          width: this.configKonva.width,
          height: this.configKonva.height,
      };
  }

  private b64toBlob(b64Data: any, contentType: any, sliceSize?: any) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

    // @mousedown="mouseDown"
   //  @touchstart
    private startDrawing(e: any) {
        this.isPaint = true;
        this.lastPointerPosition = (this.$refs.stage as any).getNode().getPointerPosition();
    }

    private stopDrawing() {
        this.isPaint = false;
    }

    private drawing() {
        if (!this.isPaint) {
          return;
        }

        this.context.globalCompositeOperation = this.erase ? 'destination-out' : 'source-over';

        this.context.beginPath();

        const stage = (this.$refs.stage as any).getNode();
        const layer = (this.$refs.drawingLayer as any).getNode();
        const image = (this.$refs.drawingImage as any).getNode();

        let localPos = {
          x: this.lastPointerPosition.x - image.x(),
          y: this.lastPointerPosition.y - image.y(),
        };
        this.context.moveTo(localPos.x, localPos.y);
        const pos = stage.getPointerPosition();
        localPos = {
          x: pos.x - image.x(),
          y: pos.y - image.y(),
        };
        this.context.lineTo(localPos.x, localPos.y);
        this.context.lineWidth = this.size;

      // set line color
        this.context.strokeStyle = this.color;
        this.context.closePath();
        this.context.stroke();

        this.lastPointerPosition = pos;
        layer.batchDraw();
    }
}
